import React, { useEffect } from 'react';
import * as S from './part-pay-tag.styles';

function PartPayTag({
  partPaymentData,
  handleTracking,
  isReviewPage = false,
  isBottomToolTip = false
}) {
  const {
    text,
    bottom_sheet,
    hover_text,
    hover_bg_clr = [],

    bg_clr = [],
    static_border_cr = [],

    info_icon,
    tag_icon,
    new_icon,
    tracking,
    hover_tracking
  } = partPaymentData;

  useEffect(() => {
    if (handleTracking && tracking) {
      handleTracking(tracking);
    }
  }, []);

  return (
    <>
      <S.PartPayWrap className="moving-border" review={isReviewPage}>
        <S.PartPayContain bgClr={bg_clr} borderClr={static_border_cr}>
          {tag_icon || new_icon ? (
            <S.NewTag className="dF">
              <S.AnimatedImg className="font13" src={tag_icon || new_icon} />
            </S.NewTag>
          ) : null}
          <div className="dF alignItemsCenter">
            <span className="f500" dangerouslySetInnerHTML={{ __html: text }}></span>
            {info_icon ? (
              <S.ToolTip>
                <img
                  src={info_icon}
                  className="icon20 marginL3"
                  onMouseEnter={() => {
                    if (handleTracking) {
                      handleTracking(hover_tracking);
                    }
                  }}
                />
                <S.Tooltiptext bgClr={hover_bg_clr} review={isReviewPage} bottom={isBottomToolTip}>
                  {hover_text ? (
                    <div className="font14" dangerouslySetInnerHTML={{ __html: hover_text }}></div>
                  ) : null}

                  {bottom_sheet ? (
                    <>
                      <div
                        className="f600 font14 padB10"
                        dangerouslySetInnerHTML={{
                          __html: bottom_sheet?.header
                        }}
                      ></div>
                      <div>
                        <S.PayOptionList className="marginL15">
                          {bottom_sheet.terms?.length
                            ? bottom_sheet.terms.map(item => (
                                <li dangerouslySetInnerHTML={{ __html: item }}></li>
                              ))
                            : null}
                        </S.PayOptionList>
                      </div>
                    </>
                  ) : null}
                </S.Tooltiptext>
              </S.ToolTip>
            ) : null}
          </div>
        </S.PartPayContain>
      </S.PartPayWrap>
    </>
  );
}

export default PartPayTag;
